import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';

export class NTAKServiceLocation extends DataModel {
  static readonly TYPE_ID = '6a9113eac4d74495bef6e2c2bfcbee4e';

  private constructor(
    public readonly uniqueId: string,
    public readonly name: string,
    public readonly organizationId: string,
    public readonly taxNumber: string,
    public readonly registrationNumber: string,
    public readonly privateKey: string,
    public readonly publicKey: string,
    public readonly certificate: string | null,
  ) {
    super();
  }

  get $typeId(): string {
    return NTAKServiceLocation.TYPE_ID;
  }

  static create(args: {
    uniqueId: string,
    name: string,
    organizationId: string,
    taxNumber: string,
    registrationNumber: string,
    privateKey: string,
    publicKey: string,
    certificate: string | null,
  }): NTAKServiceLocation {
    return new NTAKServiceLocation(
        args.uniqueId,
        args.name,
        args.organizationId,
        args.taxNumber,
        args.registrationNumber,
        args.privateKey,
        args.publicKey,
        args.certificate,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): NTAKServiceLocation {
    return NTAKServiceLocation.create({
      uniqueId: MapUtils.getString(map, 'uniqueId'),
      name: MapUtils.getString(map, 'name'),
      organizationId: MapUtils.getString(map, 'organizationId'),
      taxNumber: MapUtils.getString(map, 'taxNumber'),
      registrationNumber: MapUtils.getString(map, 'registrationNumber'),
      privateKey: MapUtils.getString(map, 'privateKey'),
      publicKey: MapUtils.getString(map, 'publicKey'),
      certificate: MapUtils.getStringOrNull(map, 'certificate'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      uniqueId: this.uniqueId,
      name: this.name,
      organizationId: this.organizationId,
      taxNumber: this.taxNumber,
      registrationNumber: this.registrationNumber,
      privateKey: this.privateKey,
      publicKey: this.publicKey,
      certificate: this.certificate,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    uniqueId = this.uniqueId,
    name = this.name,
    organizationId = this.organizationId,
    taxNumber = this.taxNumber,
    registrationNumber = this.registrationNumber,
    privateKey = this.privateKey,
    publicKey = this.publicKey,
    certificate = this.certificate,
  }: {
    uniqueId?: string,
    name?: string,
    organizationId?: string,
    taxNumber?: string,
    registrationNumber?: string,
    privateKey?: string,
    publicKey?: string,
    certificate?: string | null,
  } = {}): this {
    return NTAKServiceLocation.create({
      uniqueId,
      name,
      organizationId,
      taxNumber,
      registrationNumber,
      privateKey,
      publicKey,
      certificate,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.name === this.name &&
        other.organizationId === this.organizationId &&
        other.taxNumber === this.taxNumber &&
        other.registrationNumber === this.registrationNumber &&
        other.privateKey === this.privateKey &&
        other.publicKey === this.publicKey &&
        other.certificate === this.certificate;
  }
}

export class NTAKServiceLocationBuilder extends DataModelBuilder<NTAKServiceLocation> {
  build(context: SerializationContext, map: SerializedData): NTAKServiceLocation {
    return NTAKServiceLocation.fromMap(context, map);
  }
}
